/**
 * Executes the callback once/if the document is loaded.
 * @param {() => void} callback
 */
const ready = callback => {
    if ( document.readyState === "complete" ) callback();
    else document.addEventListener( "DOMContentLoaded", () => callback(), { once: true } );
};

export default ready;